import {
  HOME_PAGE_URL,
  CARPENTRY_PAGE_URL,
  BATHROOMS_PAGE_URL,
  GROUNDWORKS_PAGE_URL,
  BUILDING_WORK_PAGE_URL,
  CONTACT_PAGE_URL,
} from '../Constants';

export const getNavLinkItemsArray = (user) => [
  { path: HOME_PAGE_URL, label: 'Home' },
  { path: CARPENTRY_PAGE_URL, label: 'Carpentry' },
  { path: BATHROOMS_PAGE_URL, label: 'Bathrooms' },
  { path: GROUNDWORKS_PAGE_URL, label: 'Groundworks' },
  { path: BUILDING_WORK_PAGE_URL, label: 'Construction' },
  { path: CONTACT_PAGE_URL, label: 'Contact' },
];
